import { Trans } from '@lingui/macro'
import { FC } from 'react'

import { FeedObjectQuestionView, FeedUserView } from '../../../interfaces'
import AgeTypeBar from '../../bars/AgeTypeBar'
import Footer from '../../Footer'
import Header from '../../Header'
import QuestionDetails from '../QuestionDetails'
import SimilarQuestion from '../SimilarQuestion'
import styles from './QuestionPage.module.css'

interface Props {
  profiles: Array<FeedUserView>
  questionView: FeedObjectQuestionView
}

const QuestionPage: FC<Props> = props => {
  const similarContents = props.questionView.question.similarContents?.map(q => (
    <div key={q.id}>
      <SimilarQuestion answerText={q.answerText} id={q.id} questionText={q.questionText} slug={q.slug} />
      <div className={styles.emptyBar} />
    </div>
  ))
  const pageProfiles = (props.profiles || []).reduce((acc, u) => ({ ...acc, [u.userId]: u }), {} as { [id: string]: FeedUserView })
  return (
    <>
      <Header />
      <AgeTypeBar />
      <QuestionDetails pageProfiles={pageProfiles} view={props.questionView} />
      <div className={styles.grayBreak} />
      <aside className={styles.similarContents}>
        {similarContents && (
          <div className={styles.similarContentHeader}>
            <strong>
              <Trans>Similar question with answers</Trans>
            </strong>
          </div>
        )}
        {similarContents}
      </aside>
      <Footer />
    </>
  )
}

export default QuestionPage
